module.exports = __webpack_public_path__ + "img/已取消.40c04f91.svg";